// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"33196674","471":"fbcafe14","615":"cd5c4229","818":"faf86f72"}[chunkId] + ".chunk.js";
};